<gs1-notifications></gs1-notifications>
<router-outlet></router-outlet>
